<script lang="ts">
import { defineComponent, inject, ref, nextTick } from 'vue'
import { VueRecaptcha } from 'vue-recaptcha'

export default defineComponent({
  name: 'RecaptchaDefault',

  components: {
    VueRecaptcha,
  },

  props: {
    /**
     * エラーが発生した際のフラグ
     */
    isError: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    'verified',
    'expired',
  ],

  setup(_, { emit }) {
    const RECAPTCHA_SITE_KEY = inject<string>('RECAPTCHA_SITE_KEY')!
    const recaptchaToken = ref('')
    const recaptchaEl = ref()
    const mounted = ref(false)

    /**
     * reCAPTCHA 認証処理
     * @param response reCAPTCHA から返却されるトークン
     */
    const onVerified = (response: string) => {
      if (!response) return

      //検証に成功した場合に reCAPTCHA トークンが返却される
      recaptchaToken.value = String(response)
      emit('verified', String(response))
    }

    /**
     * reCAPTCHA 有効期限切れ処理
     */
    const onExpired = () => {
      recaptchaToken.value = ''
      emit('expired')
    }

    nextTick(() => {
      if (recaptchaEl.value && recaptchaEl.value.$el) {
        recaptchaEl.value.$el.style.position = 'relative'
        recaptchaEl.value.$el.style.zIndex = 2
        mounted.value = true
      }
    })

    return {
      // constants
      RECAPTCHA_SITE_KEY,

      // data
      recaptchaToken,
      recaptchaEl,
      mounted,

      // methods
      onVerified,
      onExpired,
    }
  },
})
</script>

<template>
  <div
    :class="[
      'l-unit__recaptcha',
      { 'is-error': isError && mounted },
    ]">
    <div class="l-unit__recaptcha--description">
      <VueRecaptcha
        ref="recaptchaEl"
        :sitekey="RECAPTCHA_SITE_KEY"
        :load-recaptcha-script="true"
        @verify="onVerified"
        @expired="onExpired" />

      <input
        class="input"
        type="hidden"
        name="g-recaptcha-response"
        :value="recaptchaToken">
    <!-- /.l-unit__recaptcha description --></div>
  <!-- /.l-unit__recaptcha --></div>
</template>

<style lang="sass" scoped>
.l-unit__recaptcha
  $root: &
  display: flex
  justify-content: center
  margin-top: 1.7em

  &:first-child
    margin-top: 0

  & &--description
    position: relative

    &::before
      content: ""
      width: 100%
      height: 100%
      display: block
      position: absolute
      top: -2px
      left: -2px
      background-color: transparent
      border: 1px solid transparent
      border-radius: $border-radius
      +transition($duration: $transition-long)

  &.is-error
    #{$root}--description
      &::before
        background-color: $border-alert
        border-color: $border-alert

  +breakpoint
    margin-top: 1em

    &:first-child
      margin-top: 0
</style>
